/** @file Keyframe form commands: set a value, move a key, set curves, delete keys (each one batch). */
import type { CommandCall, Curve, Doc } from '@pose2d/format/types';
import type { KeyRef } from '../../stores/types';
import { curveSetCalls } from '../curves/curveSetCalls';
import { keyCommands } from '../timeline/model/keyCommands';

/** Builders of the key commands; curves come from the curve editor (W3-43), move and delete from the dopesheet's. */
export const keyEditCalls = {
  /** animation.setKey keeps the key's curve (value only). */
  value(ref: KeyRef, value: unknown): CommandCall[] {
    return [{ name: 'animation.setKey', input: { animation: ref.animation, target: ref.target, channel: ref.channel, frame: ref.frame, value } }];
  },
  /** animation.moveKeys by the difference; none when the frame is unchanged. */
  move(ref: KeyRef, frame: number): CommandCall[] {
    return keyCommands.move([ref], frame - ref.frame);
  },
  /** animation.setCurve per curved timeline over the keys that still exist (discrete keys are skipped). */
  curve(doc: Doc, keys: readonly KeyRef[], curve: Curve): CommandCall[] {
    return curveSetCalls(doc, keys, curve);
  },
  /** animation.deleteKeys per timeline, frames ascending; draw order takes no target. */
  remove(keys: readonly KeyRef[]): CommandCall[] {
    return keyCommands.remove(keys);
  },
};
